import React from 'react';
import { useAtomValue } from 'jotai';

import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';
import SelectBudgetForm from '@/components/CustomTravel/ServiceForm/forms/SelectBudgetForm';
interface SelectBudgetProps {}

const SelectBudget: React.FC<SelectBudgetProps> = () => {
  const { budget } = useAtomValue(customTravelFormStateAtom);

  return <SelectBudgetForm externalValues={budget ? { budget } : undefined} />;
};

export default SelectBudget;
